import classNames from 'classnames';

import { MButton } from '@Components/Base';
import MPagination from '@Components/Base/Table/components/Pagination';
import { ReactComponent as NextArrowIcon } from '@Icons/additional/arrow-left.svg';

import { PaginationSettings } from './type';

import styles from './confirmation-desktop.module.css';

interface ConfirmationDesktopLayoutProps {
  backToText?: string;
  caption?: string;
  actions?: JSX.Element | null;
  content?: JSX.Element | null;
  paginationSettings?: PaginationSettings;
  hidePagination?: boolean;
  handleBack?: () => void;
  handleConfirm?: () => void;
}

const ConfirmationDesktopLayout: React.FC<ConfirmationDesktopLayoutProps> = ({
  backToText = 'Back',
  caption = 'Material Confirmation',
  actions,
  content,
  hidePagination = false,
  paginationSettings = {
    current: 0,
    onChange: () => null,
    pageSize: 0,
    total: 0,
  },
  handleBack,
  handleConfirm,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.confirmation}>
        <div className={styles.header}>
          <div className={styles.backSection}>
            <NextArrowIcon onClick={handleBack} />
            <span>{backToText}</span>
          </div>
          <div className={styles.info}>
            <div className={styles.caption}>{caption}</div>
            <div className={styles.actionGroup}>{actions}</div>
          </div>
        </div>
        <div className={styles.content}>{content}</div>
      </div>
      <div className={classNames(styles.footer, 'trojan-glassphormism-box')}>
        {!hidePagination && (
          <MPagination
            {...paginationSettings}
            showSizeChanger={false}
            showTotal={(total) => `Total ${total} items`}
          />
        )}
        <div className={styles.footerButton}>
          <MButton type="secondary" onClick={handleBack}>
            Cancel
          </MButton>
          <MButton type="primary" onClick={handleConfirm}>
            Confirm
          </MButton>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDesktopLayout;
